import { Altcha } from "./components"

export { Altcha }
